export default class CountryIso {
    code = '';
    name = '';
}